import type { EnhancedQuizResultDto, LessonDetailDto, LessonQuizDto } from '../services/contentService';
import { resolveLessonQuizzes } from './lessonJourneySteps';

export function isQuizResultPassed(result: EnhancedQuizResultDto | null | undefined): boolean {
  if (!result) return false;
  const r = result as EnhancedQuizResultDto & { Passed?: boolean };
  return r.passed === true || r.Passed === true;
}

export function isExercisePassed(result: { passed?: boolean; Passed?: boolean } | null | undefined): boolean {
  if (!result) return false;
  return result.passed === true || result.Passed === true;
}

export function patchLessonExerciseCompleted(lesson: LessonDetailDto, exerciseId: number): LessonDetailDto {
  if (!lesson.exercises?.length) return lesson;
  return {
    ...lesson,
    exercises: lesson.exercises.map((ex) =>
      ex.id === exerciseId ? { ...ex, userHasCompletedExercise: true } : ex
    )
  };
}

function patchQuizList(quizzes: LessonQuizDto[], quizId: number, score?: number): LessonQuizDto[] {
  return quizzes.map((qz) => {
    if (qz.id !== quizId) return qz;
    const prevBest = qz.userBestQuizScore ?? 0;
    const nextBest = score != null ? Math.max(prevBest, score) : qz.userBestQuizScore;
    return {
      ...qz,
      userHasPassedQuiz: true,
      ...(nextBest != null ? { userBestQuizScore: nextBest } : {})
    };
  });
}

export function patchLessonQuizPassed(
  lesson: LessonDetailDto,
  quizId: number,
  score?: number
): LessonDetailDto {
  const updated = patchQuizList(resolveLessonQuizzes(lesson), quizId, score);
  const passedQuiz = updated.find((q) => q.id === quizId);
  return {
    ...lesson,
    lessonQuizzes: updated,
    lessonQuiz: passedQuiz ?? updated[0] ?? lesson.lessonQuiz
  };
}

export function patchLessonReviewed(lesson: LessonDetailDto, reviewed: boolean): LessonDetailDto {
  return { ...lesson, isLessonReviewed: reviewed };
}

/** True when the journey step “Mark lesson as passed” is complete (`isCompleted` from the API). */
export function isLessonMarkedPassed(lesson: LessonDetailDto): boolean {
  return lesson.isCompleted === true;
}

export function patchLessonPassed(lesson: LessonDetailDto, passed: boolean): LessonDetailDto {
  if (!passed) {
    return { ...lesson, isCompleted: false };
  }
  return { ...lesson, isCompleted: true, isLessonReviewed: true };
}
